<template>
  <div class="app" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div style="position: absolute; left: 80px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <div>
      <el-row :gutter="20" style="min-width: 600px; max-width: 1450px; margin: 10px auto; padding: 0 20px;">
        <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" style="margin-bottom: 20px;">
          <div class="box2">
            <el-table :data="tableData"
              :empty-text="empty"
              style="width: 100%;">
              <el-table-column label="時間"
                width="210">
                <template slot-scope="scope">
                  <i class="el-icon-time"></i>
                  <span style="margin-left: 5px;">{{ new Date(scope.row[1].start.dateTime).toLocaleString() }}</span>
                </template>
              </el-table-column>
              <el-table-column label="活動主旨">
                <template slot-scope="scope">
                  <div style="font-weight: 600; color: #409EFF;">{{ scope.row[1].summary }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="edit"
                width="160"
                label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="checkData(scope.row)">查看</el-button>
                  <el-button size="mini" type="danger" @click="deleteEvent(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center; margin-top: 5px;">
              <i class="el-icon-circle-plus-outline plus" @click="addEvent"></i>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14" v-if="calender.calendarId !== ''">
          <iframe :src="`https://calendar.google.com/calendar/embed?src=${calender.calendarId}&wkst=1&bgcolor=%23c9d4ff&ctz=Asia%2FTaipei&showTitle=0`"
            style="border-width: 0; box-shadow: 2px 2px 4px -1px rgba(20% ,20% ,40% ,0.5);"
            width="100%"
            height="600"
            frameborder="0"
            scrolling="no">
          </iframe>
        </el-col>
      </el-row>
    </div>
    <!-- 沒有開通日曆 -->
    <mu-dialog :open="!enabled" width="550" title="系統通知">
      <div>此帳號目前還沒開通預訂功能，如有需求請前往 <a style="color: #fff; background-color: #00c300; padding: 5px; border-radius: 5px;" href="https://line.me/R/ti/p/%40fva0918s" target="blank">LINE@</a> 洽詢。</div>
      <mu-button slot="actions" color="primary" @click="goback">知道了</mu-button>
    </mu-dialog>
    <!-- 活動資訊 -->
    <el-dialog :visible="editDia"
      :show-close="false"
      width="650px">
      <div style="text-align: center; margin-bottom: 15px;" v-if="eventId !== ''">
        <el-radio-group v-model="radio1" fill="#666">
          <el-radio-button label="活動資訊"></el-radio-button>
          <el-radio-button :label="`申請名單(${calender.reserve.length})`"></el-radio-button>
        </el-radio-group>
      </div>
      <!-- <div style="display: inline-block; padding: 3px 15px; background-color: #777; color: #fff; font-size: 16px; margin-bottom: 10px; font-weight: 500; border-radius: 3px;">活動資訊</div> -->
      <el-row :gutter="20" v-if="radio1 === '活動資訊' || eventId === ''">
        <el-col :span="12">
          <!-- 標題 -->
          <div id="summary" style="margin-bottom: 15px;">
            <div style="font-size: 15px; font-weight: 500; margin-bottom: 7px;">活動主旨:</div>
            <el-input placeholder="請輸入活動名稱"
              v-model="calender.summary">
            </el-input>
          </div>
          <!-- 地點 -->
          <div id="location" style="margin-bottom: 15px;">
            <div style="font-size: 15px; font-weight: 500; margin-bottom: 7px;">活動地點:</div>
            <el-input placeholder="請輸入活動地點"
              v-model="calender.location">
            </el-input>
          </div>
          <!-- 活動敘述 -->
          <div id="location">
            <div style="font-size: 15px; font-weight: 500; margin-bottom: 7px;">活動敘述:</div>
            <el-input placeholder="請輸入活動敘述"
              v-model="calender.description">
            </el-input>
          </div>
        </el-col>
        <el-col :span="12">
          <!-- 人數 -->
          <div id="summary" style="margin-bottom: 15px;">
            <div style="font-size: 15px; font-weight: 500; margin-bottom: 7px;">人數限制:</div>
            <el-input placeholder="請輸入人數限制"
              v-model="calender.maxAttendees">
            </el-input>
          </div>
          <!-- 時間 -->
          <div class="block" style="margin-bottom: 15px;">
            <div style="font-size: 15px; font-weight: 500; margin-bottom: 7px;">開始時間:</div>
            <el-date-picker v-model="calender.start"
              style="width: 100%;"
              type="datetime"
              placeholder="選擇開始時間">
            </el-date-picker>
          </div>
          <!-- 時間 -->
          <div class="block">
            <div style="font-size: 15px; font-weight: 500; margin-bottom: 7px;">結束時間:</div>
            <el-date-picker v-model="calender.end"
              style="width: 100%;"
              type="datetime"
              placeholder="選擇結束時間">
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <div v-if="eventId !== '' && radio1 !== '活動資訊'" style="margin-top: 20px;">
        <!-- <hr style="border: 0.5px solid #999; margin-bottom: 10px;"/> -->
        <!-- <div style="display: inline-block; padding: 3px 15px; background-color: #E6A23C; color: #fff; font-size: 16px; margin-bottom: 10px; font-weight: 500; border-radius: 3px;">申請名單</div> -->
        <el-table :data="calender.reserve"
          empty-text="暫無報名"
          style="width: 100%">
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div>{{ scope.row.displayName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="電子郵件"
            width="210">
            <template slot-scope="scope">
              <div>{{ scope.row.email }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作"
            width="180">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="checkUser(scope.row, scope.$index)" v-if="!accepted(scope.row)">核准</el-button>
              <el-button size="mini" type="success" v-if="accepted(scope.row)" disabled>已核准</el-button>
              <el-button size="mini" type="danger" @click="confirmReject(scope.row, scope.$index)">刪除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <br/>
      <!-- 按鈕 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDia = false">返 回</el-button>
        <el-button type="primary" @click="checkValue" v-if="eventId === ''">新 增</el-button>
        <el-button type="primary" v-if="eventId !== ''" @click="beforeUpdate = true">儲存變更</el-button>
      </span>
    </el-dialog>
    <!-- 確認更新 -->
    <el-dialog title="活動更新訊息(非必要)" :visible="beforeUpdate" :show-close="false">
      <el-input type="textarea"
        v-model="updateMsg"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="如果需要傳送訊息通知用戶，請在此輸入內容">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeUpdate = false">返 回</el-button>
        <el-button type="primary" @click="updateCalender">確 定</el-button>
      </span>
    </el-dialog>
    <!-- 確認刪除 -->
    <el-dialog title="活動刪除訊息(非必要)" :visible="removeDia" :show-close="false">
      <el-input type="textarea"
        v-model="removeMsg"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="如果需要傳送訊息通知用戶，請在此輸入內容">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="removeDia = false">返 回</el-button>
        <el-button type="primary" @click="removePush">確 定</el-button>
      </span>
    </el-dialog>
    <!-- 刪除訊息 -->
    <el-dialog title="確定刪除此筆預定"
      :visible.sync="deleteDia"
      width="450px">
      <el-input type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="請說明婉拒原因，系統將會傳送給該用戶"
        v-model="deleteData.replyMsg">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDia = false">取 消</el-button>
        <el-button type="primary" @click="deletePush">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable */
export default {
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      pageLoading: false,
      editDia: false,
      enabled: true,
      tableData: [],
      eventId: '',
      empty: '載入中...',
      radio1: '活動資訊',
      calender: {
        service: this.$route.params.service,
        auth: this.$route.params.id,
        calendarId: '',
        reserve: [],
        summary: '',
        location: '',
        description: '',
        maxAttendees: 0,
        start: '',
        end: ''
      },
      removeMsg: '',
      updateMsg: '',
      beforeUpdate: false,
      deleteDia: false,
      removeDia: false,
      deleteData: {
        idx: 0,
        replyMsg: '',
        user: {
          displayName: '',
          email: '',
          status: '',
          token: ''
        }
      }
    };
  },
  mounted() {
    this.getEvent();
  },
  methods: {
    ...mapActions({
      updateEvent: 'updateEvent',
      deleteEvent: 'deleteEvent',
      checkAccount: 'checkAccount',
      getEventDetail: 'getEventDetail',
      updateUserStatus: 'updateUserStatus'
    }),
    showFlassMessage(message, time) {
      this.$notify({
        title: message,
        type: 'success'
      });
    },
    showDialog(val) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (!val) {
        loading.close();
      }
    },
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    getEvent() {
      const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      this.checkAccount({ Service: this.service, Auth: this.auth })
        .then((res) => {
          loading.close();
          if (res.calender) {
            this.enabled = true;
            this.calender.calendarId = res.calender.id;
            if (res.calender.events) {
              this.tableData = Object.entries(res.calender.events).sort((a, b) => new Date(a[1].start.dateTime) - new Date(b[1].start.dateTime));
            }
            else {
              this.tableData = [];
            }
            this.empty = '目前無活動';
          }
          else {
            this.enabled = false;
          }
        })
    },
    checkUser(row, index) {
      this.showDialog(true);
      const userData = {
        email: row.email,
        displayName: row.displayName,
        token: row.token,
        responseStatus: 'accepted'
      };
      this.updateUserStatus({ service: this.service, auth: this.auth, calendarId: this.calender.calendarId, eventId: this.eventId, userData: userData })
        .then(() => {
          this.getEvent();
          this.showDialog(false);
          this.$set(this.calender.reserve[index], 'status', 'accepted');
        })
    },
    confirmReject(row, index) {
      this.deleteData.user = row;
      this.deleteData.idx  = index;
      this.deleteDia       = true;
    },
    accepted(row) {
      if (row.status && row.status === 'accepted') {
        return true;
      }
      return false;
    },
    deleteEvent(row, index) {
      this.eventId   = row[0];
      this.removeDia = true;
    },
    checkData(row) {
      this.showDialog(true);
      this.eventId = row[0];
      this.radio1  = '活動資訊';
      this.getEventDetail({ service: this.service, auth: this.auth, eventId: row[0] })
        .then((res) => {
          this.showDialog(false);
          this.editDia          = true;
          this.calender         = res.data;
          this.calender.reserve = res.data.reserve ? Object.values(res.data.reserve) : [];
          this.calender.start   = new Date(res.data.start.dateTime);
          this.calender.end     = new Date(res.data.end.dateTime);
        });
    },
    addEvent() {
      this.eventId = '';
      this.editDia = true;
    },
    removePush() {
      this.showDialog(true);
      this.removeDia = false;
      this.deleteEvent({ service: this.service, auth: this.auth, calendarId: this.calender.calendarId, eventId: this.eventId, replyMsg: this.removeMsg })
        .then(() => {
          this.showDialog(false);
          this.getEvent();
        })
    },
    deletePush() {
      this.showDialog(true);
      const userData = {
        responseStatus: 'declined',
        email: this.deleteData.user.email,
        token: this.deleteData.user.token,
        displayName: this.deleteData.user.displayName,
      };
      this.updateUserStatus({ service: this.service, auth: this.auth, calendarId: this.calender.calendarId, eventId: this.eventId, replyMsg: this.deleteData.replyMsg, userData: userData })
        .then(() => {
          this.getEvent();
          this.showDialog(false);
          this.calender.reserve.splice(this.deleteData.idx, 1);
          this.deleteDia = false;
        })
    },
    updateCalender() {
      this.beforeUpdate = false;
      this.editDia      = false;
      this.pageLoading  = true;
      const postData = {
        service: this.service,
        auth: this.auth,
        calendarId: this.calender.calendarId,
        eventId: this.eventId,
        replyMsg: this.updateMsg,
        eventDetail: {
          summary: this.calender.summary,
          location: this.calender.location ? this.calender.location : null,
          description: this.calender.description ? this.calender.description : null,
          maxAttendees: this.calender.maxAttendees ? parseInt(this.calender.maxAttendees) : null,
          start: {
            dateTime: new Date(this.calender.start).toISOString(),
            timeZone: 'Asia/Taipei'
          },
          end: {
            dateTime: new Date(this.calender.end).toISOString(),
            timeZone: 'Asia/Taipei'
          }
        }
      };
      this.updateEvent(postData).then(() => {
        this.pageLoading = false;
        this.showFlassMessage('更新成功', 1000);
      })
    },
    checkValue() {
      this.editDia = false;
      const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      const startTime = new Date(this.calender.start).getTime();
      const endTime = new Date(this.calender.end).getTime();
      this.calender.maxAttendees = parseInt(this.calender.maxAttendees);
      this.calender.start = startTime;
      this.calender.end = endTime;
      // 打資料
      const apiUrl = 'https://member-card.herokuapp.com/insertEvent';
      this.axios.post(apiUrl, this.calender).then((res) => {
        window.location.reload();
        loading.close();
      })
    }
  }
}
</script>

<style scoped>
  .box2 {
    padding: 15px;
    padding-bottom: 25px;
    background-color: #fff;
    border-radius: 3px;
    margin: 0 auto;
    box-shadow: 2px 2px 4px -1px rgba(20% ,20% ,40% ,0.5);
    position: relative;
  }
  .plus:hover {
    color: rgb(64, 158, 255);
  }
  .plus {
    transition: 0.2s;
    cursor: pointer;
    font-size: 30px;
    margin-top: 10px;
    font-weight: 500;
    color: #777;
  }
</style>